import { createActions } from 'redux-actions';

export const {
  updateFilterFieldsOrders,
  searchOrders,
  changeTypeListOrders,
  countFiltersOrders,
  resetFiltersOrders,
} = createActions(
  'UPDATE_FILTER_FIELDS_ORDERS',
  'SEARCH_ORDERS',
  'CHANGE_TYPE_LIST_ORDERS',
  'COUNT_FILTERS_ORDERS',
  'RESET_FILTERS_ORDERS'
);
